import React, { useState, useEffect } from "react"
import Select from 'react-select';

import API from '../../tools/API';
import style from './Modal.module.scss';
import { singleCathegory, SingleChannel, SingleSelectedChannel } from '../../tools/interfaces';

interface ModalData {
    id: number | undefined,
    name: string | undefined,
    generate: boolean | undefined
}

interface EditCategory {
    openModal: React.Dispatch<React.SetStateAction<ModalData | boolean>>
    editData: any;
}



const EditCategoryModal: React.FC<EditCategory> = ({ openModal, editData }) => {
    const [name, setName] = useState(editData.name);
    const [generate, setGenerete] = useState(editData.generate);
    const [stationsIdList, setStationIdList] = useState([]);
    const [selectedStation, setSelectedStation] = useState<SingleSelectedChannel | null>(null);
    const [fullData, setFullData] = useState<singleCathegory | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        if (editData.id) {
            API.getSingleCategory(editData.id).then(res => {
                setFullData(res?.data.data)
            })
        }
    }, [editData.id])

    useEffect(() => {
        if (fullData) {
            API.getListOffRadioIds().then(res => {
                const stationArr = res?.data.data;
                if (stationArr) {
                    const mappedStationList = stationArr.map((x: SingleChannel) => {
                        return (
                            {
                                value: x.id,
                                label: x.name
                            }
                        )
                    })
                    setStationIdList(mappedStationList);
                    setSelectedStation(mappedStationList.filter((x: SingleSelectedChannel) => x.value === fullData.appId)[0])
                }
            })
        }

    }, [fullData])

    const postEditedCategory = () => {
        if (name && fullData && selectedStation) {
            API.editCategory(name, fullData.id, generate, selectedStation?.value)
                .then(res => {
                    openModal(false);
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    setError(err.response.data.Exception);
                })
        }
    }

    const customStyles = {
        indicatorsContainer: () => ({
            backgroundColor: '#e10626',
            borderRadius: '50%',
            marginLeft: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }),
        control: () => ({
            display: 'flex',
            padding: '5px 13px 5px 13px',
            backgroundColor: '#eff1f6',
            border: '1px solid #cacaca',
            borderRadius: '20px',
            fontSize: '18px',
            fontWeight: '500',
            color: '#555454'
        }),
        dropdownIndicator: () => ({
            color: 'white',
            padding: '5px 7px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        })
    }


    return (
        <div className={style.AddCathegory}>
            <h2 className={style.AddCathegory__title} >Edytuj kategorię</h2>
            {stationsIdList &&
                (
                    <form className={style.AddCathegory__form}>
                        <Select
                            className={style.AddCathegory__selector}
                            value={selectedStation}
                            onChange={(e) => {
                                setSelectedStation(e)
                            }}
                            options={stationsIdList}
                            placeholder={"Wybierz stację"}
                            styles={customStyles}
                        />
                        <input
                            type="text"
                            id="cathegoryName"
                            placeholder="Nazwa"
                            className={style.AddCathegory__formInput}
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value)
                            }}
                        />
                        <div className={style.AddCathegory__container}>
                            <label
                                htmlFor="automatGenerate"
                                className={style.AddCathegory__formLabel}
                            >
                                Automatycznie generuj następne głosowanie:
                            </label>
                            <input
                                type="checkbox"
                                id="automatGenerate"
                                name="automatGenerate"
                                className={style.AddCathegory__checkbox}
                                checked={generate}
                                onChange={(e) => {
                                    setGenerete(e.target.checked)
                                }}
                            />
                        </div>
                        {!loading ? <input
                            type="button"
                            value="ZAPISZ"
                            className={style.AddCathegory__button}
                            onClick={(e) => {
                                e.preventDefault();
                                setLoading(true);
                                postEditedCategory();
                            }}
                        /> : <p className={style.loader}>Trwa dodawanie...</p>
                        }
                        {error &&
                            <div className={style.addPoll__row}>
                                <p className={style.errorText}>{error}</p>
                            </div>
                        }
                    </form>
                )
            }
        </div>
    )
}

export default EditCategoryModal; 